import AlarmList from './AlarmList';
import HeaderMenu from '../menu/HeaderMenu'
import FooterMenu from '../menu/FooterMenu'

const Alert = (props) => {

    return (
        <div>
            <HeaderMenu />
            <AlarmList />
            <FooterMenu />
        </div>
    );
};

export default Alert;